import API from './API';

export default class CurrencyCode extends API {
  constructor(parameters = {}) {
    super('/Currency', parameters);
  }
}
